import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

export default function GroupCreateDialog({ open, onClose, onSave }) {
    const [form, setForm] = useState({
        windcontract_group_name: "",
        note: "",
    });

    const handleSave = () => {
        if (!form.windcontract_group_name) {
            alert("請輸入群組名稱");
            return;
        }
        onSave({ windcontract_group_name: form.windcontract_group_name, note: form.note });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                新增群組
                <IconButton aria-label="close" onClick={onClose} style={{ position: "absolute", right: 8, top: 8 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <TextField
                    label="群組名稱"
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    value={form.windcontract_group_name}
                    onChange={(e) => setForm({ ...form, windcontract_group_name: e.target.value })}
                />
                <TextField
                    label="備註"
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    multiline
                    minRows={3}
                    value={form.note}
                    onChange={(e) => setForm({ ...form, note: e.target.value })}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSave} variant="contained" style={{ backgroundColor: "#5597b4", color: "#fff" }}>建立</Button>
                <Button onClick={onClose}>取消</Button>
            </DialogActions>
        </Dialog>
    );
}
